export var MEDIA_MAX_MOBILE = '(max-width: 767px)';
export var MEDIA_MAX_TABLET = '(max-width: 1024px)';
export var HEADER_TABLET_LAYOUT = '(max-width: 1700px)';
export var HEADER_MIN_TABLET_LAYOUT = '(max-width: 1248px)';
export var MEDIA_MAX_TABLET_XL = '(max-width: 1247px)';
export var DESKTOP = '(min-width: 1025px) and (max-width: 1440px)';
export var MOBILE = '(max-width: 767px)';